import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { IMyDpOptions, IMyDateModel, IMyDate} from "mydatepicker";
import "../../../../assets/semantic/semantic.min.js";

import { CompanyService } from "../../../_services/company.service";
import { PlanningService } from "../../../_services/planning.service";
import { ClientService } from "../../../_services/client.service";
import { PlanningPalettesService } from "../../../_services/planning-palettes.service";
import { SecurityService } from "../../../_services/security.service";

import * as moment from 'moment';

declare var jQuery: any;

@Component({
  selector: "app-client-dashboard",
  templateUrl: "./client-dashboard.component.html",
  styleUrls: ["./client-dashboard.component.css"],
})

export class ClientDashboardComponent implements OnInit {
  private total: number;
  private total_incidents: number;
  private marge: number = 0.00;
  private percent;
  private from;
  private to;
  private destinataire;
  private destinataire_list: Array<string>;
  private palettes;
  private planning_palettes;
  private emissions: number = 0;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "dd/mm/yyyy",
    openSelectorOnInputClick: true,
    editableDateField: false,
  };

  constructor(
    private service: ClientService,
    private security: SecurityService,
    private company: CompanyService,
    private pps: PlanningPalettesService
  ) { }
  
  filters = new FormGroup({
    client_id: new FormControl(),
    warehouse_id: new FormControl(),
    from: new FormControl(),
    to: new FormControl(),
    destinataire_client: new FormControl()

  })
  formatDate(date): string {
    moment.locale('fr');
    const formattedDate = moment(date, 'YYYY-MM-DD HH:mm:ss').format('ddd DD-MM-YYYY');
    return formattedDate || '';
  }

  setDate(): void {
    this.from = moment().startOf('month').format('YYYY-MM-D');
    this.to = moment().endOf('month').format('YYYY-MM-D');

    let startOfMonth = moment().startOf('month');
    let endOfMonth = moment().endOf('month');
    
    this.filters.patchValue(
    {
      from: {
        date: {
          year: startOfMonth.format('YYYY'),
          month: startOfMonth.format('MM'),
          day: startOfMonth.format('D')
        }
      },
      to: {
        date: {
          year: endOfMonth.format('YYYY'),
          month: endOfMonth.format('MM'),
          day: endOfMonth.format('D')
        }
      }
    });
  }
  ngOnInit() {
    this.destinataire_list = [];
    this.setDate();

    this.getAll();

    this.getPalettes();

    this.filters.valueChanges.debounceTime(250).subscribe((value) => {
      if (value.from && value.from.formatted) {
        this.from = value.from.jsdate;
        value.from = value.from.formatted;
      }
      if (value.to && value.to.formatted) {
        this.to = value.to.jsdate;
        value.to = value.to.formatted;
      }
      if (value.destinataire_client) {
        this.destinataire = value.destinataire_client;
      } else {
        this.destinataire = "";
      }

      this.getAll(value);
      this.getPalettes(value);
    });    
  }
  
  getPalettes(client = null) {
    let params = {};
    Object.assign(params, { from: this.from, to: this.to });
    
    if (client) {
      Object.assign(params, {
        client_id: client.client_id,
        warehouse_id: client.warehouse_id
      });
    }
  
    this.palettes = {
      total_chargees: 0,
      total_rendues: 0,
      total_livrees: 0,
      total_reprises: 0,
      solde_entrepot: 0,
      solde_transporteur: 0,
    };
    
    this.pps.getAllPalettes(params).subscribe((response) => {

      let palettes = this.palettes;

      this.planning_palettes = response.palettes.map(function (palette) {
        
        palettes.total_chargees += palette.chargees;
        palettes.total_rendues += palette.rendues;
        palettes.total_livrees += palette.livrees;
        palettes.total_reprises += palette.reprises;

        return palette;
      });

      this.palettes.solde_entrepot = (this.palettes.total_livrees - this.palettes.total_reprises);
      this.palettes.solde_transporteur = (this.palettes.total_rendues - this.palettes.total_chargees);
    });
  }

  getAll(client = null) {
    let params = {};
    this.emissions = 0;
    Object.assign(params, {
      from: this.from,
      to: this.to,
      destinataire_client: this.destinataire
    });

    if (client) {
      Object.assign(params, { client_id: client.client_id });
    }
    
    this.service.countAll(params).subscribe((total) => {
      let percent = 0;
      let reverse = 0;
      this.total = total.length;
      this.marge = 0;

      let incidents = total.filter((planning) => (planning.state == 1 || planning.incidents.length > 0));
      this.total_incidents = incidents.length;
      total.forEach(single => {
        this.marge = this.marge + (single.sell_price - single.buy_price);
        if (single.destinataire_client) {
          this.destinataire_list.push(single.destinataire_client);
        }
        if (single.co2_emis) {
          this.emissions += parseFloat(single.co2_emis);
        }
      });
      
      let desti_list = this.destinataire_list;
      let newArray = desti_list.filter(function(item, index) {
        if (desti_list.indexOf(item) == index)
          return item;
      });
      this.destinataire_list = newArray;
      this.marge = parseFloat(this.marge.toFixed(2));
      
      if (total.length > 0) {
        percent = Math.round((incidents.length *100)/ total.length );
        reverse = 100 - percent;
      }

      jQuery('#total').progress({
        percent: reverse
      });
      
    })
  }

}


// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/client/client-dashboard/client-dashboard.component.ts